import React, { useEffect, useMemo, useState } from "react";
import FileUpload from "components/UI/FileUpload";
import { axiosCitajteo } from "common/api/axios/citajteo_axios";
import { FILE_UP_NAME } from "constant/file/file_constants";
import styled from "styled-components";
import { DlUnit } from "model/dl_unit/DlUnit";
import UnitPdfFileName from "./UnitPdfFileName";
import AppLink from "components/common/style/link/AppLink";
import { splitPath } from "common/util/file/file_common";

type UnitPdfFileEditProps = {
  unit: DlUnit;
};

const UnitPdfFileEdit = ({ unit }: UnitPdfFileEditProps) => {
  const initialFileName: string = useMemo(() => unit.pdfFileNameGet(), [unit]);
  const initialPdfFold: string = useMemo(() => unit.pdfFoldGet(), [unit]);
  const [fileName, setFileName] = useState<string>(initialFileName);
  const [pdfFold, setPdfFold] = useState<string>(initialPdfFold);
  const [showUpdate, setShowUpdate] = useState<boolean>(false);
  const pdfLinkUrl = useMemo(
    () => unit.getPdfStaticUrl({ fold: pdfFold, nam: fileName }),
    [unit, pdfFold, fileName],
  );

  useEffect(() => {
    if (fileName !== initialFileName && !showUpdate) {
      setShowUpdate(true);
    }
  }, [fileName, initialFileName, showUpdate]);

  const fileUploadHandle = (data: any) => {
    console.log("fileUploadHandle", data);
    const fNam = data.files[0].filename;
    const fPN = splitPath(data.files[0].path);
    if (fPN.length >= 2) {
      const fold = fPN[fPN.length - 2];
      if (fold !== pdfFold) {
        setPdfFold(fold);
      }
    }
    setFileName(fNam);
  };

  const resetFileName = () => {
    setFileName(initialFileName);
    setShowUpdate(false);
  };

  const removeFileName = () => {
    setFileName("");
  };

  const pdfApiUpUrl = `dl-unit/${unit.id}/pdf/file`;

  return (
    <Div>
      <div>Pdf</div>
      {fileName && (
        <FileNameNavDiv>
          {pdfLinkUrl ? (
            <AppLink to={pdfLinkUrl} target="_blank">
              {fileName}
            </AppLink>
          ) : (
            <span>{fileName}</span>
          )}
          <RemoveFileNameButton
            type="button"
            onClick={removeFileName}
            aria-label={`Obriši pdf ${fileName}`}
          >
            ×
          </RemoveFileNameButton>
        </FileNameNavDiv>
      )}

      <FileUpload
        axiosInstance={axiosCitajteo}
        fileFieldName={FILE_UP_NAME}
        fileUploadHandle={fileUploadHandle}
        uploadUrl={pdfApiUpUrl}
        multiple={false}
      />
      {showUpdate && (
        <UnitPdfFileName
          unitId={unit.id}
          fileName={fileName}
          setFileName={setFileName}
          resetFileName={resetFileName}
        />
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const RemoveFileNameButton = styled.button`
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-size: 1.1rem;
  line-height: 1;
  padding: 0;
`;

const FileNameNavDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export default UnitPdfFileEdit;
